export const DISABLE_ENOVIA = true;
export const LS_ENOVIA_IGNORE = "enovia__ignore";
export const LS_ENOVIA_USERNAME = "enovia__username";
export const LS_ENOVIA_PASSWORD = "enovia__password";
